import moment from "moment"

// ✅ Get previous Saturday safely
export const getPreviousSaturday = date => {
  if (!date) return null

  const d = moment(
    date,
    ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", moment.ISO_8601],
    true
  )
  if (!d.isValid()) return null

  const day = d.day() // 0=Sun ... 6=Sat

  // Calculate days to subtract to reach previous Saturday
  const daysToSaturday = day === 6 ? 7 : (day + 1) % 7

  return d.clone().subtract(daysToSaturday, "days")
}

// ✅ Get week tooltip label safely
export const getWeekTooltipLabel = (index, date) => {
  if (!date) return `W-${index + 1} : - — -`

  const dataPointDate = moment(date, "DD-MM-YYYY")
  if (!dataPointDate.isValid()) return `W-${index + 1} : - — -`

  const previousSaturday = getPreviousSaturday(date)
  const prevSatStr = previousSaturday?.isValid()
    ? previousSaturday.format("DD-MM-YYYY")
    : "-"

  return `W-${index + 1} :  ${dataPointDate.format("DD-MM-YYYY")}`
}

export const getSameWeekPreviousYear = dateStr => {
  if (!dateStr) return null

  const date = moment(dateStr, "DD-MM-YYYY")
  const originalWeek = date.isoWeek()

  // Try 52 weeks back
  const minus52 = date.clone().subtract(52, "weeks")

  if (minus52.isoWeek() === originalWeek) {
    return minus52.format("DD-MM-YYYY")
  }

  // // Fallback: 53 weeks back
  // return date.clone().subtract(53, "weeks").format("DD-MM-YYYY")
}

export const getSameWeekNextYear = dateStr => {
  if (!dateStr) return null

  const date = moment(dateStr, "DD-MM-YYYY")
  const originalWeek = date.isoWeek()

  // Try 52 weeks forward
  const plus52 = date.clone().add(52, "weeks")
  if (plus52.isoWeek() === originalWeek) {
    return plus52.format("DD-MM-YYYY")
  }

  // // Fallback: 53 weeks forward
  // return date.clone().add(53, "weeks").format("DD-MM-YYYY")
}
